
import React from "react";
import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";

const HowItWorksCard: React.FC = () => {
  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">How It Works</h2>
      <ol className="space-y-3 list-decimal list-inside text-gray-700">
        <li>Request a swap for this reagent</li>
        <li>Offer your own reagent or credits</li>
        <li>If accepted, arrange shipping details</li>
        <li>Complete the exchange</li>
      </ol>
      <Separator className="my-4" />
      <p className="text-sm text-gray-600">
        Need help? <Link to="/help" className="text-reagent-blue hover:underline">Visit our Help Center</Link>
      </p>
    </div>
  );
};

export default HowItWorksCard;
